import {
  formatarMilhar,
  formatarPorcentagemValorAbsoluto,
  limitarLabel,
  toTitleCase,
} from '../../../../helpers/formatador';

export const getColumns = () =>
  [
    {
      header: 'Transportadora',
      accessor: 'nomeTransportadora',
      format: value => limitarLabel(toTitleCase(value), 30),
      rowSize: '24%',
    },
    {
      header: 'Volume (ton)',
      accessor: 'volume',
      format: value => formatarMilhar(value),
      rowSize: '12%',
    },
    {
      header: 'Lote',
      accessor: 'lote',
      rowSize: '12%',
    },
    {
      header: 'Demanda',
      accessor: 'demanda',
      rowSize: '12%',
    },
    {
      header: 'Share (volume)',
      accessor: 'share',
      format: value => `${formatarPorcentagemValorAbsoluto(value)}`,
      rowSize: '16%',
    },
    {
      header: 'Aderência ',
      accessor: 'aderencia',
      format: value => `${formatarPorcentagemValorAbsoluto(value)}`,
      rowSize: '12%',
    },
    {
      header: 'Qtd. motoristas',
      accessor: 'quantidadeMotoristas',
      rowSize: '12%',
    },
  ].filter(Boolean);
